import { QRCodeSVG } from 'qrcode.react';
import { Flex, Title } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import Modal from 'rsuite/Modal';
import { MdQrCode2 as IconQRCode } from 'react-icons/md';
import { COLOURS } from '../styles';
import { insertSpace } from '../utils/utilities';
import { encode_mac_address, getMacAddressFromUID } from '../utils/uid';
import { getControllerBrandIcon_FROM_STRING, convertDeviceToIconNumber } from './DisplayItems';

export const ShowDeviceQR = ({ open, device, handleClose }) => {
  const textStyle = {
    textAlign: 'center',
    fontFamily: 'monospace',
    fontSize: 'larger',
    fontWeight: '600',
  };
  const generateQR = (e) => {
    var mac_address = encode_mac_address(
      getMacAddressFromUID(e.uniqueDeviceId),
      convertDeviceToIconNumber(e.modelType),
    );

    return mac_address;
  };
  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static" size="xs">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <div className="space-y-2">
            <Flex justifyContent="center" alignItems="center" className="space-x-1">
              <Icon icon={IconQRCode} color={COLOURS.default} />
              <Title color={COLOURS.default}>{device.userName} </Title>
            </Flex>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex justifyContent="center" alignItems="center" className="space-x-1">
          <QRCodeSVG
            value={generateQR(device)}
            size={256}
            fgColor={'#0056d6'}
            level={'L'}
            includeMargin={false}
            imageSettings={{
              src: getControllerBrandIcon_FROM_STRING(device.modelType),
              x: undefined,
              y: undefined,
              height: 48,
              width: 48,
              excavate: true,
            }}
          />
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <div style={textStyle}>{insertSpace(device.uniqueDeviceId)}</div>
        <Flex justifyContent="center" alignItems="center" className="space-x-2">
          <Button color={COLOURS.default} size="sm" onClick={() => handleClose({ device })} disabled={false}>
            Ok
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
